module.exports = __webpack_public_path__ + "img/bjx_detail_table_01.20efd9a2.png";